<template>
  <div
      class="max-w-[425px] bg-white h-screen mx-auto"
  >
    <div
        id="app"
        class="max-w-[425px] bg-white lg:pb-[20%] pb-[25%] mx-auto px-[15px]  border-x-gray-[#E6E6E6] border-x"
    >
      <div
          class="relative flex items-center justify-between lg:pt-[20px] md:pt-[20px] pt-[15px]"
      >
        <div
            :class="{ hidden: step === 21 }"
            class="absolute left-0 h-0 w-full border-b-[2px] bg-[#E6E6E6]"
        />
        <div
            v-for="stp in steps"
            :key="stp"
            :class="{
            'bg-Primary7 ': step === stp,
            ' bg-white ': step < stp,
            'bg-Primary7': step > stp,
            hidden: step === 21,
          }"
            class="bg-[#E6E6E6] w-[8px] h-[8px] mx-[2px] leading-[25px] text-center inline-block rounded-full relative z-10 mx-0"
            @click="step > stp ? (step = stp) : ''"
        >
          <div
              v-if="step > stp"
              :class="{
              'absolute right-0 h-0 w-[26px] border-b-Primary7 border-b-[2px] top-[2.5px] lg:top-[3px] z-10':
                step > stp,
            }"
          />
        </div>
      </div>
      <div
          :class="{ hidden: step === 21 }"
          class="flex justify-center items-center mt-[30px]"
      >
        <div
            class="text-center bg-[#FBF9FF] rounded-full w-[100px] mx-2 py-2 text-Primary6 text-[16px]"
        >
          {{ this.step }}
          از 20
        </div>
      </div>
      <div v-if="step === 5" class="relative">
        <div class="text-center lg:mb-8 mt-4 mb-7">
          <div
              class="text-[#555555] text-[16px] font-[600] text-center mb-[30px]"
          >
            گزارش BMI
          </div>
        </div>
        <div
            v-if="this.bmiResult"
            class="flex flex-col items-center justify-center"
        >
          <div
              id="bmiResult"
              :class="{
              low1: this.bmiResult <= 18,
              normal1: this.bmiResult >= 19 && this.bmiResult <= 24,
              overWeight1: this.bmiResult >= 25 && this.bmiResult <= 29,
              fat2: this.bmiResult >= 30 && this.bmiResult <= 34,
              fat3: this.bmiResult >= 35,
            }"
              class="hidden absolute top-[58px] flex flex-col items-center justify-center"
          >
            <div
                :class="{
                'text-[#931A24]': this.bmiResult >= 35,
                'text-[#E76C00]': this.bmiResult >= 30 && this.bmiResult <= 34,
                'text-[#F8B600]': this.bmiResult >= 25 && this.bmiResult <= 29,
                'text-[#00B97D]': this.bmiResult >= 19 && this.bmiResult <= 24,
                'text-[#24BDDF]': this.bmiResult <= 18,
              }"
                class="text-[20px]"
            >
              {{ this.bmiResult }}
            </div>
            <select-back2 v-if="this.bmiResult >= 35"/>
            <select-back3 v-if="this.bmiResult >= 30 && this.bmiResult <= 34"/>
            <under-number v-if="this.bmiResult >= 25 && this.bmiResult <= 29"/>
            <select-back4 v-if="this.bmiResult >= 19 && this.bmiResult <= 24"/>
            <select-back5 v-if="this.bmiResult <= 18"/>
          </div>
        </div>
        <div class="flex justify-center relative lg:mb-[23px] mt-10 mb-8">
          <count-svg/>
          <div
              class="absolute bottom-0 flex flex-col justify-center items-center"
          >
            <div id="bmi" class="absolute -bottom-[65px]">
              <pointer-svg/>
            </div>
            <div class="text-[14px] text-Primary6">BMI</div>
          </div>
        </div>
        <div class="lg:w-[325px] mx-auto w-[290px]">
          <div
              class="bg-[#F8F8F8] rounded-lg h-[48px] mb-[8px] flex justify-start items-center px-[6px]"
          >
            <warning-svg/>
            <div class="lg:text-[14px] text-[13px] ml-[24px] font-[500] text-[#686868] mr-[8px] flex">
              دوست عزیز شما
              <div v-if="this.add_weight > 0" class="flex">
                <div class="mx-1 text-[#C5292A] text-[14px]">{{ this.add_weight }}</div>
                <div>کیلو اضافه وزن دارید.</div>
              </div>
              <div v-else class="flex">
                <div class="mx-1 text-[#C5292A] text-[14px]">{{ this.less_weight }}</div>
                <div>کیلو کمبود وزن دارید.</div>
              </div>
            </div>

          </div>
          <div
              class="bg-[#F8F8F8] rounded-lg h-[48px] mb-[8px] flex items-center px-[9px] justify-between"
          >
            <div class="flex items-center">
              <weight-svg/>
              <div class="lg:text-[14px] text-[13px] ml-[24px] font-[500] text-[#686868] mr-[10px] flex items-center ">
                <div> وزن ایده‌آل شما</div>
              </div>
            </div>
            <div class="flex items-center ml-1">
              <div class="font-[700] text-[#00B97D] mx-2">{{this.normal_weight}}</div>
              <div class="text-[10px] text-[#909090]">کیلوگرم</div>
            </div>

          </div>
          <div
              class="bg-[#F8F8F8] rounded-lg h-[48px] mb-[23px] flex items-center px-[6px] justify-between"
          >
            <div class="flex items-center">
              <clock-svg/>
              <div class="lg:text-[14px] text-[13px] ml-[24px] font-[500] text-[#686868] mr-[8px] flex items-center ">
                <div>زمان رسیدن به وزن ایده‌آل</div>
              </div>
            </div>
            <div class="flex items-center ml-2">
              <div class="font-[700] text-[#8050CD] mx-2">{{this.months}}</div>
              <div class="text-[10px] text-[#909090]">ماه</div>
            </div>
          </div>
        </div>
        <div class="bg-[#F0F0F0] w-full h-[1px] mb-6"></div>
      </div>
      <div>
        <div
            v-if="step === 3"
            class="text-[#555555] text-[16px] mt-[16px] font-[600] text-center mb-[40px] margin_custom"
        >
          وزنت چقدره ؟
        </div>
        <div
            v-if="step === 4"
            class="text-[#555555] text-[16px] mt-[16px] font-[600] text-center mb-[40px] margin_custom"
        >
          قدت چقدره ؟
        </div>
      </div>
      <div
          v-if="step === 3 || step === 4"
          class="flex justify-center items-center"
      >
        <div v-if="form.gender === 0">
        <div v-if="step === 4">
          <thin-female
              v-if="this.bmiResult <= 18"
          />
          <normal-female
              v-if="this.bmiResult >= 19 && this.bmiResult <= 24"
          />
          <over-weight-female
              v-if="this.bmiResult >= 25 && this.bmiResult <= 29"
          />
          <fat-female
              v-if="this.bmiResult >= 30 && this.bmiResult <= 34"
          />
          <supper-fat-female v-if="this.bmiResult >= 35"/>
        </div>
        <div v-if="step === 3">
          <thin-female
              v-if="
              Number(this.state.weight) >= 0 && Number(this.state.weight) <= 50
            "
              :class="{ hidden: Number(this.state.weight) >= 50 }"
          />
          <normal-female
              v-if="
              Number(this.state.weight) >= 50 && Number(this.state.weight) <= 65
            "
              :class="{ hidden: Number(this.state.weight) >= 65 }"
          />
          <over-weight-female
              v-if="
              Number(this.state.weight) >= 65 && Number(this.state.weight) <= 75
            "
              :class="{ hidden: Number(this.state.weight) >= 75 }"
          />
          <fat-female
              v-if="
              (Number(this.state.weight) >= 75 &&
                Number(this.state.weight) <= 80) ||
              (Number(this.state.weight) >= 80 &&
                Number(this.state.weight) <= 90)
            "
              :class="{ hidden: Number(this.state.weight) >= 90 }"
          />

          <supper-fat-female v-if="Number(this.state.weight) >= 90"/>
        </div>
        </div>
        <div v-else-if="form.gender === 1">
          <div v-if="step === 4">
            <thin-male
                v-if="this.bmiResult <= 18"
            />
            <normal-male
                v-if="this.bmiResult >= 19 && this.bmiResult <= 24"
            />
            <over-weight-male
                v-if="this.bmiResult >= 25 && this.bmiResult <= 29"
            />
            <fat-male
                v-if="this.bmiResult >= 30 && this.bmiResult <= 34"
            />
            <supper-fat-male v-if="this.bmiResult >= 35"/>
          </div>
          <div v-if="step === 3">
            <thin-male
                v-if="
              Number(this.state.weight) >= 0 && Number(this.state.weight) <= 50
            "
                :class="{ hidden: Number(this.state.weight) >= 50 }"
            />
            <normal-male
                v-if="
              Number(this.state.weight) >= 50 && Number(this.state.weight) <= 65
            "
                :class="{ hidden: Number(this.state.weight) >= 65 }"
            />
            <over-weight-male
                v-if="
              Number(this.state.weight) >= 65 && Number(this.state.weight) <= 75
            "
                :class="{ hidden: Number(this.state.weight) >= 75 }"
            />
            <fat-male
                v-if="
              (Number(this.state.weight) >= 75 &&
                Number(this.state.weight) <= 80) ||
              (Number(this.state.weight) >= 80 &&
                Number(this.state.weight) <= 90)
            "
                :class="{ hidden: Number(this.state.weight) >= 90 }"
            />

            <supper-fat-male v-if="Number(this.state.weight) >= 90"/>
          </div>
        </div>
      </div>
      <div
          v-if="step === 3 || step === 4"
          class="flex justify-center lg:mb-14 md:mb-14 mb-5 mb_custom"
      >
        <back-ground/>
      </div>
      <div class="">
        <keep-alive>
          <form v-if="step === 1" class="mt-5" @submit.prevent="gender">
            <div
                class="text-[#555555] text-[16px] font-[600] text-center mb-[40px] margin_custom"
            >
              جنسیت خودت رو انتخاب کن
            </div>
            <div class="bg-white text-[#AAAAAA] rounded-md">
              <div
                  class="flex flex-col items-center justify-center lg:mb-14 md:mb-14 mb-5 mb_custom"
              >
                <woman-svg v-if="form.gender === 0"/>
                <man-svg v-if="form.gender === 1"/>
                <back-ground/>
              </div>
              <label
                  :class="{
                  'border border-Primary9 bg-[#F8F2FF] rounded-lg text-Primary7':
                    form.gender === 0,
                }"
                  class="label w-full flex bg-[#F8F8F8] justify-center rounded-lg gap-5 items-center py-3 text-sm tracking-tighter mb-[16px]"
                  @click="form.gender = 0"
              >
                <input
                    v-model="form.gender"
                    checked="checked"
                    class="hidden"
                    name="gender"
                    type="radio"
                    value="0"
                />
                <female-svg/>
                <div class="text-[14px] font-[500]">خانم</div>
              </label>
              <label
                  :class="{
                  'border border-Primary9 bg-[#F8F2FF] rounded-lg text-Primary7':
                    form.gender === 1,
                }"
                  class="label w-full flex justify-center bg-[#F8F8F8] gap-7 py-3 rounded-lg items-center text-sm tracking-tighter"
                  @click="form.gender = 1"
              >
                <input
                    v-model="form.gender"
                    class="hidden"
                    name="gender"
                    type="radio"
                    value="1"
                />
                <male-svg/>
                <div class="text-[14px] font-[500]">آقا</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple w-[92%]">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </form>
        </keep-alive>
        <keep-alive>
          <form v-if="step === 2" key="age" @submit.prevent="next">
            <div
                class="text-[#555555] text-[16px] mt-[16px] font-[600] text-center mb-[40px] margin_custom"
            >
              چند سالته؟
            </div>
            <div
                class="flex flex-col items-center justify-center lg:mb-14 md:mb-14 mb-5 mb_custom"
            >
              <woman-svg v-if="form.gender === 0"/>
              <man-svg v-if="form.gender === 1"/>
              <back-ground/>
            </div>
            <slider v-model="state.age" type="age"></slider>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </form>
        </keep-alive>
        <keep-alive>
          <form v-if="step === 3" key="weight" @submit.prevent="next">
            <slider v-model="state.weight" type="weight"></slider>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="finalCalc">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </form>
        </keep-alive>
        <keep-alive>
          <form v-if="step === 4" key="height" @submit.prevent="next">
            <slider v-model="state.height" type="height" @normalBmi="finalCalc"></slider>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="bmiCalculating">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </form>
        </keep-alive>
        <keep-alive>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
                v-if="step === 5"
                @submit.prevent="handleSubmit(handleMobile)"
            >
              <div class="bg-white rounded-2xl w-full">
                <div>
                  <p class="text-[#555555] text-[16px] font-[600] mb-[24px]">
                    شماره موبایلتو وارد کن تا اطلاعات بیشتری دریافت کنی:
                  </p>
                </div>
                <div class="flex gap-1">
                  <text-input
                      id="errors"
                      v-model="form.mobile"
                      name="mobile"
                      placeholder="مثلا ...۰۹۱۲۳۴"
                      rules="required"
                      type="number"
                      @update="emptyInput"
                  />
                  <country-flag-code @codeUpdate="inputValiation"/>
                </div>
                <div
                    v-if="form.mobile !== ''"
                    id="error"
                    class="text-[12px] text-red-600 mt-1"
                ></div>
                <div
                    v-if="form.mobile.length < 10"
                    id="error2"
                    class="text-[12px] text-red-600 mt-1"
                ></div>
                <div class="fixed">
                  <div
                      class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                      style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
                  >
                    <ButtonComponent class="purple-line w-[45%]" @click="back">
                      مرحله قبل
                    </ButtonComponent>
                    <ButtonComponent
                        id="disabledButton"
                        :class="form.mobile ? 'purple' : 'disable-mode'"
                        class="w-[45%]"
                    >
                      مرحله بعد
                    </ButtonComponent>
                  </div>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 6" class="bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2 mt-4">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                بیشتر چربی ها در کدوم نواحی بدنته؟
              </div>
            </div>
            <div>
              <div class="flex gap-[16px] mb-[16px]">
                <label
                    :class="
                    form.fatAround === 1
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 1"
                >
                  <input
                      v-model="form.fatAround"
                      checked="checked"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="1"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <full-fat-top/>
                    <div
                        :class="
                        form.fatAround === 1
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      چربی کامل بالای بدن
                    </div>
                  </div>
                </label>
                <label
                    :class="
                    form.fatAround === 2
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 2"
                >
                  <input
                      v-model="form.fatAround"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="2"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <under-fat/>
                    <div
                        :class="
                        form.fatAround === 2
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      چربی زیر شکم
                    </div>
                  </div>
                </label>
              </div>
              <div class="flex gap-[16px] mb-[16px]">
                <label
                    :class="
                    form.fatAround === 3
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-center text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 3"
                >
                  <input
                      v-model="form.fatAround"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="3"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <belly-fat/>
                    <div
                        :class="
                        form.fatAround === 3
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      چربی شکم با چربی بالای کمر
                    </div>
                  </div>
                </label>
                <label
                    :class="
                    form.fatAround === 4
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-center text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 4"
                >
                  <input
                      v-model="form.fatAround"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="4"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <lower-body-fat/>
                    <div
                        :class="
                        form.fatAround === 4
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      چربی پایین بدن
                    </div>
                  </div>
                </label>
              </div>
              <div class="flex gap-[16px] mb-[16px]">
                <label
                    :class="
                    form.fatAround === 5
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-center text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 5"
                >
                  <input
                      v-model="form.fatAround"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="5"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <belly-chuby/>
                    <div
                        :class="
                        form.fatAround === 5
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      تورم معده
                    </div>
                  </div>
                </label>
                <label
                    :class="
                    form.fatAround === 6
                      ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                      : 'text-[#686868]'
                  "
                    class="w-full p-[16px] rounded-lg text-center text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                    @click="form.fatAround = 6"
                >
                  <input
                      v-model="form.fatAround"
                      class="hidden"
                      name="fatAround"
                      type="radio"
                      value="6"
                  />
                  <div class="flex flex-col justify-center items-center">
                    <full-lower-fat/>
                    <div
                        :class="
                        form.fatAround === 6
                          ? 'text-Primary6 bg-[#F8F2FF]'
                          : 'text-[#686868]'
                      "
                        class="text-[14px] mt-[16px]"
                    >
                      چربی شکم با چربی بالای کمر
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 7" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                دچار چه بیماری هایی هستی؟
              </div>
            </div>
            <div class="flex items-center rounded-md gap-2">
              <text-area v-model="form.disease" placeholder="بنویس..."/>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 8" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                چقدر در طول روز فعالیت داری؟
              </div>
            </div>
            <div class="flex flex-col rounded-md gap-2 pt-[50px]">
              <label
                  :class="
                  form.activity === 1
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] px-[11px] rounded-lg text-sm tracking-tighter"
                  @click="form.activity = 1"
              >
                <input
                    v-model="form.activity"
                    checked="checked"
                    class="hidden"
                    name="activity"
                    type="radio"
                    value="1"
                />
                <div class="flex items-center mb-[13px]">
                  <very-low-activity
                      :class="{ 'text-[#B0B0B0]': form.activity !== 1 }"
                  />
                  <div class="pr-[16px]">فعالیت خیلی کم</div>
                </div>
                <div
                    :class="
                    form.activity === 1 ? 'text-[#8050CD]' : 'text-[#909090]'
                  "
                    class="text-[12px] font-[400] block"
                >
                  بدون ورزش و محدود به کار های روزانه یا مبتلا به بیماری های
                  حرکتی مانند (دیسک کمر، آرتروز و ...)
                </div>
              </label>
              <label
                  :class="
                  form.activity === 2
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] px-[11px] rounded-lg text-sm tracking-tighter"
                  @click="form.activity = 2"
              >
                <input
                    v-model="form.activity"
                    class="hidden"
                    name="activity"
                    type="radio"
                    value="2"
                />
                <div class="flex items-center mb-[13px]">
                  <low-activity
                      :class="{ 'text-[#B0B0B0]': form.activity !== 2 }"
                  />
                  <div class="pr-7">فعالیت کم</div>
                </div>
                <div
                    :class="
                    form.activity === 2 ? 'text-[#8050CD]' : 'text-[#909090]'
                  "
                    class="text-[12px] font-[400] block"
                >
                  کارمندان، پیاده روی و در حد ورزش های سبک
                </div>
              </label>
              <label
                  :class="
                  form.activity === 3
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] px-[11px] rounded-lg text-sm tracking-tighter"
                  @click="form.activity = 3"
              >
                <input
                    v-model="form.activity"
                    class="hidden"
                    name="activity"
                    type="radio"
                    value="3"
                />
                <div class="flex items-center mb-[13px]">
                  <normal-activity
                      :class="{ 'text-[#B0B0B0]': form.activity !== 3 }"
                  />
                  <div class="pr-6">فعالیت متوسط</div>
                </div>
                <div
                    :class="
                    form.activity === 3 ? 'text-[#8050CD]' : 'text-[#909090]'
                  "
                    class="text-[12px] font-[400] block"
                >
                  ۳ روز در هفته حداقل یک ساعت ورزش غیر سبک
                </div>
              </label>
              <label
                  :class="
                  form.activity === 4
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] px-[11px] rounded-lg text-sm tracking-tighter"
                  @click="form.activity = 4"
              >
                <input
                    v-model="form.activity"
                    class="hidden"
                    name="activity"
                    type="radio"
                    value="4"
                />
                <div class="flex items-center mb-[13px]">
                  <heavy-activity
                      :class="{ 'text-[#B0B0B0]': form.activity !== 4 }"
                  />
                  <div class="pr-6">فعالیت سنگین</div>
                </div>
                <div
                    :class="
                    form.activity === 5 ? 'text-[#8050CD]' : 'text-[#909090]'
                  "
                    class="text-[12px] font-[400] block"
                >
                  بیشتر از ۳ روز در هفته ورزش حرفه ای و سنگین
                </div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 9" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                قبلا سابقه رژیم داشتی؟
              </div>
            </div>
            <div class="flex items-center rounded-md gap-2">
              <label
                  :class="
                  form.diet === 1
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                  @click="form.diet = 1"
              >
                <input
                    v-model="form.diet"
                    checked="checked"
                    class="hidden"
                    name="diet"
                    type="radio"
                    value="1"
                />
                <div>بله</div>
              </label>
              <label
                  :class="
                  form.diet === 2
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                  @click="form.diet = 2"
              >
                <input
                    v-model="form.diet"
                    class="hidden"
                    name="diet"
                    type="radio"
                    value="2"
                />
                <div>خیر</div>
              </label>
            </div>
            <div v-if="form.diet === 1">
              <text-input
                  v-model="form.dietKind"
                  class="mt-3 mb-8"
                  placeholder="چه نوع رژیمی گرفته بودی؟"
              />
              <div class="text-[#555555] text-[14px] font-[600] mt-[20px] mb-4">
                از رژیمت راضی بودی؟
              </div>
              <div class="flex items-center rounded-md gap-2 mb-3">
                <label
                    :class="
                    form.satisfied === 1
                      ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                      : 'text-[#686868]'
                  "
                    class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                    @click="form.satisfied = 1"
                >
                  <input
                      v-model="form.satisfied"
                      checked="checked"
                      class="hidden"
                      name="satisfied"
                      type="radio"
                      value="1"
                  />
                  <div>بله</div>
                </label>
                <label
                    :class="
                    form.satisfied === 2
                      ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                      : 'text-[#686868]'
                  "
                    class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                    @click="form.satisfied = 2"
                >
                  <input
                      v-model="form.satisfied"
                      class="hidden"
                      name="diet"
                      type="radio"
                      value="2"
                  />
                  <div>خیر</div>
                </label>
              </div>
              <text-input
                  v-model="form.quitCause"
                  placeholder="دلیل راضی یا ناراضی بودنت رو بنویس..."
              />
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 10" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                انگیزت برای شروع رژیم چقدره؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.motivation === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.motivation = 1"
              >
                <input
                    v-model="form.motivation"
                    checked="checked"
                    class="hidden"
                    name="motivation"
                    type="radio"
                    value="1"
                />
                <div>کاملا آماده ام و امروز می خوام شروع کنم</div>
              </label>
              <label
                  :class="
                  form.motivation === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.motivation = 2"
              >
                <input
                    v-model="form.motivation"
                    class="hidden"
                    name="motivation"
                    type="radio"
                    value="2"
                />
                <div>آمادگی رو دارم در حال بررسی انواع رژیم ها هستم</div>
              </label>
              <label
                  :class="
                  form.motivation === 3
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-center text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.motivation = 3"
              >
                <input
                    v-model="form.motivation"
                    class="hidden"
                    name="motivation"
                    type="radio"
                    value="3"
                />
                <div>
                  تقریبا آماده هستم ولی انگیزه شروع رو ندارم هیچ امیدی ندارم
                </div>
              </label>
              <label
                  :class="
                  form.motivation === 4
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.motivation = 4"
              >
                <input
                    v-model="form.motivation"
                    class="hidden"
                    name="motivation"
                    type="radio"
                    value="4"
                />
                <div>هیچ امید و انگیزه ای ندارم</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 11" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                چرا می خواهی وزن کم کنی؟
              </div>
            </div>
            <div class="w-full flex flex-col items-center rounded-md gap-2">
              <check-box
                  v-model="form.con1"
                  :class="
                  form.con1 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="دوست دارم لباس مورد علاقم رو بپوشم"
              />
              <check-box
                  v-model="form.con2"
                  :class="
                  form.con2 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="سلامتیمون دچار مشکل شده"
              />
              <check-box
                  v-model="form.con3"
                  :class="
                  form.con3 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="به خاطر شرایط محیط کارم"
              />
              <check-box
                  v-model="form.con4"
                  :class="
                  form.con4 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="راه رفتن برام مشکل شده، زود خسته میشم"
              />
              <check-box
                  v-model="form.con5"
                  :class="
                  form.con5 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="به خاطر وزنم، مهمونی نمی تونم برم"
              />
              <check-box
                  v-model="form.con6"
                  :class="
                  form.con6 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="به خاطر اصرار همسرم"
              />
              <check-box
                  v-model="form.con7"
                  :class="
                  form.con7 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="از این که بقیه خوش اندام هستند حسرت می خورم"
              />
              <check-box
                  v-model="form.con8"
                  :class="
                  form.con8 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="وزنم خوبه، می خوام حفظش کنم."
              />
              <check-box
                  v-model="form.con9"
                  :class="
                  form.con9 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="اعتماد به نفس خیلی کم شده"
              />
              <check-box
                  v-model="form.con10"
                  :class="
                  form.con10 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="دوست دارم که جوان تر بشم"
              />
              <text-input
                  v-model="form.weightCause"
                  placeholder="موارد دیگر..."
              />
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 12" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                در طول روز چقدر استرس داری؟
              </div>
            </div>
            <div
                class="flex flex-col items-center justify-center rounded-md gap-2"
            >
              <label
                  :class="
                  form.stress === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.stress = 1"
              >
                <input
                    v-model="form.stress"
                    checked="checked"
                    class="hidden"
                    name="stress"
                    type="radio"
                    value="1"
                />
                <div>خدا رو شکر استرس ندارم</div>
              </label>
              <label
                  :class="
                  form.stress === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.stress = 2"
              >
                <input
                    v-model="form.stress"
                    class="hidden"
                    name="stress"
                    type="radio"
                    value="2"
                />
                <div>یکم استرس دارم</div>
              </label>
              <label
                  :class="
                  form.stress === 3
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.stress = 3"
              >
                <input
                    v-model="form.stress"
                    class="hidden"
                    name="stress"
                    type="radio"
                    value="3"
                />
                <div>همیشه استرس دارم</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 13" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                عاشق کدوم غذا یا خوراکی هستی؟
              </div>
            </div>
            <div class="flex items-center rounded-md gap-2">
              <text-area v-model="form.foodLover" placeholder="بنویس..."/>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 14" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                از کدوم غذا یا خوراکی متنفری ؟
              </div>
            </div>
            <div class="flex items-center rounded-md gap-2">
              <text-area v-model="form.foodHater" placeholder="بنویس..."/>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 15" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                چند بار در هفته غذای بیرونی می خوری؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.outFood === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.outFood = 1"
              >
                <input
                    v-model="form.outFood"
                    checked="checked"
                    class="hidden"
                    name="outFood"
                    type="radio"
                    value="1"
                />
                <div>هر روز</div>
              </label>
              <label
                  :class="
                  form.outFood === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.outFood = 2"
              >
                <input
                    v-model="form.outFood"
                    class="hidden"
                    name="outFood"
                    type="radio"
                    value="2"
                />
                <div>یک روز در میان</div>
              </label>
              <label
                  :class="
                  form.outFood === 3
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.outFood = 3"
              >
                <input
                    v-model="form.outFood"
                    class="hidden"
                    name="outFood"
                    type="radio"
                    value="3"
                />
                <div>دو روز در هفته</div>
              </label>
              <label
                  :class="
                  form.outFood === 4
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.outFood = 4"
              >
                <input
                    v-model="form.outFood"
                    class="hidden"
                    name="outFood"
                    type="radio"
                    value="4"
                />
                <div>خیلی کم</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 16" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                کدوم عادت ها رو داری؟
              </div>
            </div>
            <div class="w-full flex flex-col items-center rounded-md gap-2">
              <check-box
                  v-model="form.eating"
                  :class="
                  form.eating === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="تند تند غذا می خورم"
              />
              <check-box
                  v-model="form.eating1"
                  :class="
                  form.eating1 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="معمولا حواسم به غذا خوردنم نیست"
              />
              <check-box
                  v-model="form.eating2"
                  :class="
                  form.eating2 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="هر موقع شیرینی می بینم می خورم"
              />
              <check-box
                  v-model="form.eating3"
                  :class="
                  form.eating3 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="درست لقمه رو نمی جوم"
              />
              <check-box
                  v-model="form.eating4"
                  :class="
                  form.eating4 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="وقتی عصبانی یا نگران میشم خیلی می خورم"
              />
              <check-box
                  v-model="form.eating5"
                  :class="
                  form.eating5 === true
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  title="بلافاصله بعد از غذا، می خوابم"
              />
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 17" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                آیا به راحتی خوابت می بره؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.sleep === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.sleep = 1"
              >
                <input
                    v-model="form.sleep"
                    checked="checked"
                    class="hidden"
                    name="sleep"
                    type="radio"
                    value="1"
                />
                <div>بله</div>
              </label>
              <label
                  :class="
                  form.sleep === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.sleep = 2"
              >
                <input
                    v-model="form.sleep"
                    class="hidden"
                    name="sleep"
                    type="radio"
                    value="2"
                />
                <div>خیر</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 18" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                وضع مالی برای تهیه مواد غذایی چطور هست ؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.financial === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.financial = 1"
              >
                <input
                    v-model="form.financial"
                    checked="checked"
                    class="hidden"
                    name="financial"
                    type="radio"
                    value="1"
                />
                <div>عالی هیچ مشکلی ندارم</div>
              </label>
              <label
                  :class="
                  form.financial === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.financial = 2"
              >
                <input
                    v-model="form.financial"
                    class="hidden"
                    name="financial"
                    type="radio"
                    value="2"
                />
                <div>بد نیست کم و بیش می تونم بخرم</div>
              </label>
              <label
                  :class="
                  form.financial === 3
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.financial = 3"
              >
                <input
                    v-model="form.financial"
                    class="hidden"
                    name="financial"
                    type="radio"
                    value="3"
                />
                <div>متاسفانه اوضاع خوبی ندارم</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 19" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                چقدر با روش لاغری ما آشنایی داری؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.loosingWeight === 1
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.loosingWeight = 1"
              >
                <input
                    v-model="form.loosingWeight"
                    checked="checked"
                    class="hidden"
                    name="loosingWeight"
                    type="radio"
                    value="1"
                />
                <div>دکتر کرمانی رو از قدیم میشناسم</div>
              </label>
              <label
                  :class="
                  form.loosingWeight === 2
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.loosingWeight = 2"
              >
                <input
                    v-model="form.loosingWeight"
                    class="hidden"
                    name="loosingWeight"
                    type="radio"
                    value="2"
                />
                <div>قبلا با شما رژیم گرفتم</div>
              </label>
              <label
                  :class="
                  form.loosingWeight === 3
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.loosingWeight = 3"
              >
                <input
                    v-model="form.loosingWeight"
                    class="hidden"
                    name="loosingWeight"
                    type="radio"
                    value="3"
                />
                <div>چند نفر از آشنایان، با رژیم شما لاغر شدند</div>
              </label>
              <label
                  :class="
                  form.loosingWeight === 4
                    ? 'border border-Primary9 text-Primary6 bg-[#F8F2FF]'
                    : 'text-[#686868]'
                "
                  class="w-full py-[11px] rounded-lg text-[14px] font-[500] flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter"
                  @click="form.loosingWeight = 4"
              >
                <input
                    v-model="form.loosingWeight"
                    class="hidden"
                    name="loosingWeight"
                    type="radio"
                    value="4"
                />
                <div>به تازگی آشنا شدم و هیچ شناختی از شما ندارم</div>
              </label>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 20" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                نیاز هست با شما تماس بگیریم و باز هم بهمون اطلاعات بدی ؟
              </div>
            </div>
            <div class="flex flex-col items-center rounded-md gap-2">
              <label
                  :class="
                  form.info === 1
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] text-center rounded-lg flex justify-center items-center text-sm tracking-tighter"
                  @click="form.info = 1"
              >
                <input
                    v-model="form.info"
                    checked="checked"
                    class="hidden"
                    name="info"
                    type="radio"
                    value="1"
                />
                <div>نه پرسشنامه عالی بود همه چیز رو گفتم</div>
              </label>
              <div v-if="form.info === 1" class="mb-5">
                <div
                    class="text-[#555555] text-[14px] text-center font-[600] mt-[20px] mb-4"
                >
                  برای خوش اندام شدنت تصمیم گرفتی؟
                </div>
                <div class="flex flex-col items-center rounded-md gap-2">
                  <label
                      :class="
                      form.paying === 1
                        ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                        : 'text-[#686868]'
                    "
                      class="w-full bg-[#F8F8F8] text-[14px] font-[500] px-4 py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                      @click="form.paying = 1"
                  >
                    <input
                        v-model="form.paying"
                        checked="checked"
                        class="hidden"
                        name="paying"
                        type="radio"
                        value="1"
                    />
                    <div>بله همین الان پرداخت می کنم</div>
                  </label>
                  <label
                      :class="
                      form.paying === 2
                        ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                        : 'text-[#686868]'
                    "
                      class="w-full bg-[#F8F8F8] text-[14px] font-[500] px-4 py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                      @click="form.paying = 2"
                  >
                    <input
                        v-model="form.paying"
                        class="hidden"
                        name="paying"
                        type="radio"
                        value="2"
                    />
                    <div>بله تصمیم گرفتم اما فعلا نمی تونم پرداخت کنم</div>
                  </label>
                </div>
              </div>
              <label
                  :class="
                  form.info === 2
                    ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                    : 'text-[#686868]'
                "
                  class="w-full bg-[#F8F8F8] text-[14px] font-[500] py-[11px] text-center rounded-lg flex justify-center items-center text-sm tracking-tighter"
                  @click="form.info = 2"
              >
                <input
                    v-model="form.info"
                    class="hidden"
                    name="info"
                    type="radio"
                    value="2"
                />
                <div>آره شرایط خاصی دارم که بهتون باید بگم</div>
              </label>
            </div>
            <div v-if="form.info === 2">
              <div class="text-[#555555] text-[14px] font-[600] mt-[20px] mb-4">
                رو این خط واتساپ داری؟
              </div>
              <div class="flex items-center rounded-md gap-2 mb-3">
                <label
                    :class="
                    form.contact === 1
                      ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                      : 'text-[#686868]'
                  "
                    class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                    @click="form.contact = 1"
                >
                  <input
                      v-model="form.contact"
                      checked="checked"
                      class="hidden"
                      name="contact"
                      type="radio"
                      value="1"
                  />
                  <div>بله</div>
                </label>
                <label
                    :class="
                    form.contact === 2
                      ? 'bg-[#F8F2FF] border text-Primary6 border-Primary9'
                      : 'text-[#686868]'
                  "
                    class="w-[50%] bg-[#F8F8F8] text-[14px] font-[500] py-[11px] rounded-lg flex justify-center items-center text-sm tracking-tighter"
                    @click="form.contact = 2"
                >
                  <input
                      v-model="form.contact"
                      class="hidden"
                      name="contact"
                      type="radio"
                      value="2"
                  />
                  <div>خیر</div>
                </label>
              </div>
              <ValidationObserver v-slot="{ handleSubmit }">
                <form
                    v-if="form.contact === 2"
                    class="pt-4 pb-20 bg-white rounded-2xl w-full"
                    @submit.prevent="handleSubmit(handleMobile)"
                >
                  <div>
                    <p
                        class="text-[#555555] text-center text-[16px] font-[600] mb-[24px]"
                    >
                      شماره واتس آپت رو وارد کن
                    </p>
                  </div>
                  <div class="flex gap-1">
                    <text-input
                        id="errors"
                        v-model="form.mobile"
                        name="mobile"
                        placeholder="مثلا ...۰۹۱۲۳۴"
                        rules="required"
                        type="number"
                        @update="emptyInput"
                    />
                    <country-flag-code @codeUpdate="inputValiation"/>
                  </div>
                  <div
                      v-if="form.mobile !== ''"
                      id="error"
                      class="text-[12px] text-red-600 mt-1"
                  ></div>
                  <div
                      v-if="form.mobile.length < 10"
                      id="error2"
                      class="text-[12px] text-red-600 mt-1"
                  ></div>
                  <ButtonComponent
                      id="disabledButton2"
                      class="disable-mode w-full mt-5"
                      disabled
                  >
                    ثبت شماره
                  </ButtonComponent>
                </form>
              </ValidationObserver>
              <div class="fixed">
                <div
                    class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                    style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
                >
                  <ButtonComponent class="purple-line w-[45%]" @click="back">
                    مرحله قبل
                  </ButtonComponent>
                  <ButtonComponent class="purple w-[45%]" @click="next">
                    مرحله بعد
                  </ButtonComponent>
                </div>
              </div>
            </div>
            <div class="fixed">
              <div
                  class="flex justify-center gap-2.5 items-center mx-auto inset-x-0 lg:w-[425px] md:w-[425px] bg-white fixed bottom-0 h-[70px]"
                  style="box-shadow: 0 -2px 15px rgb(0 0 0 / 0.1)"
              >
                <ButtonComponent class="purple-line w-[45%]" @click="back">
                  مرحله قبل
                </ButtonComponent>
                <ButtonComponent class="purple w-[45%]" @click="next">
                  مرحله بعد
                </ButtonComponent>
              </div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div v-if="step === 21" class="p-4 bg-white rounded-2xl w-full">
            <div class="font-semibold mb-2">
              <div
                  class="text-[#555555] text-[16px] font-[600] text-center mb-[40px]"
              >
                نامه اعمال
              </div>
            </div>
            <div v-if="this.form.gender" class="flex">
              <div>جنسیت :</div>
              <div v-if="this.form.gender === 0">خانوم</div>
              <div v-else-if="this.form.gender === 1">آقا</div>
            </div>
            <div>
              <div v-if="this.state.age" class="flex">
                <div>سن :</div>
                <div>{{ this.state.age }}</div>
              </div>
            </div>
            <div>
              <div v-if="this.state.weight" class="flex">
                <div>وزن :</div>
                <div>{{ this.state.weight }}</div>
              </div>
            </div>
            <div>
              <div v-if="this.state.height" class="flex">
                <div>قد :</div>
                <div>{{ this.state.height }}</div>
              </div>
            </div>
            <div
                v-if="
                this.form.con1 ||
                this.form.con2 ||
                this.form.con3 ||
                this.form.con4 ||
                this.form.con5 ||
                this.form.con6 ||
                this.form.con7 ||
                this.form.con8 ||
                this.form.con9 ||
                this.form.con10
              "
                class="my-5"
            >
              <div>چرا می خواهی وزن کم کنی؟</div>
              <div v-if="this.form.con1">
                دوست دارم لباس مورد علاقم رو بپوشم
              </div>
              <div v-if="this.form.con2">سلامتیمون دچار مشکل شده</div>
              <div v-if="this.form.con3">به خاطر شرایط محیط کارم</div>
              <div v-if="this.form.con4">
                راه رفتن برام مشکل شده، زود خسته میشم
              </div>
              <div v-if="this.form.con5">به خاطر وزنم، مهمونی نمی تونم برم</div>
              <div v-if="this.form.con6">به خاطر اصرار همسرم</div>
              <div v-if="this.form.con7">
                از این که بقیه خوش اندام هستند حسرت می خورم
              </div>
              <div v-if="this.form.con8">وزنم خوبه، می خوام حفظش کنم.</div>
              <div v-if="this.form.con9">اعتماد به نفس خیلی کم شده</div>
              <div v-if="this.form.con10">دوست دارم که جوان تر بشم</div>
              <div v-if="this.form.weightCause">
                {{ this.form.weightCause }}
              </div>
            </div>
            <div v-if="this.form.stress">
              <div>در طول روز چقدر استرس داری؟</div>
              <div v-if="this.form.stress === 1">خدا رو شکر استرس ندارم</div>
              <div v-else-if="this.form.stress === 2">یکم استرس دارم</div>
              <div v-else-if="this.form.stress === 3">همیشه استرس دارم</div>
            </div>
            <div v-if="this.form.outFood" class="my-5">
              <div>چند بار در هفته غذای بیرونی می خوری؟</div>
              <div v-if="this.form.outFood === 1">هر روز</div>
              <div v-else-if="this.form.outFood === 2">یک روز در میان</div>
              <div v-else-if="this.form.outFood === 3">دو روز در هفته</div>
              <div v-else-if="this.form.outFood === 4">خیلی کم</div>
            </div>
            <div v-if="this.form.sleep">
              <div>آیا به راحتی خوابت می بره؟</div>
              <div v-if="this.form.sleep === 1">بله</div>
              <div v-else-if="this.form.sleep === 2">خیر</div>
            </div>
            <div v-if="this.form.motivation" class="my-5">
              <div>انگیزت برای شروع رژیم چقدره؟</div>
              <div v-if="this.form.motivation === 1">
                کاملا آماده ام و امروز می خوام شروع کنم
              </div>
              <div v-else-if="this.form.motivation === 2">
                آمادگی رو دارم در حال بررسی انواع رژیم ها هستم
              </div>
              <div v-else-if="this.form.motivation === 3">
                تقریبا آماده هستم ولی انگیزه شروع رو ندارمهیچ امید و انگیزه ای
                ندارم
              </div>
              <div v-else-if="this.form.motivation === 4">
                هیچ امید و انگیزه ای ندارم
              </div>
            </div>
            <div
                v-if="
                this.form.eating ||
                this.form.eating1 ||
                this.form.eating2 ||
                this.form.eating3 ||
                this.form.eating4 ||
                this.form.eating5
              "
            >
              <div>کدوم عادت ها رو داری؟</div>
              <div v-if="this.form.eating">تند تند غذا می خورم</div>
              <div v-if="this.form.eating1">
                معمولا حواسم به غذا خوردنم نیست
              </div>
              <div v-if="this.form.eating2">هر موقع شیرینی می بینم می خورم</div>
              <div v-if="this.form.eating3">درست لقمه رو نمی جوم</div>
              <div v-if="this.form.eating4">
                وقتی عصبانی یا نگران میشم خیلی می خورم
              </div>
              <div v-if="this.form.eating5">بلافاصله بعد از غذا، می خوابم</div>
            </div>
            <div v-if="this.form.financial" class="my-5">
              <div>وضع مالی برای تهیه مواد غذایی چطور هست ؟</div>
              <div v-if="this.form.financial === 1">عالی هیچ مشکلی ندارم</div>
              <div v-else-if="this.form.financial === 2">
                بد نیست کم و بیش می تونم بخرم
              </div>
              <div v-else-if="this.form.financial === 3">
                متاسفانه اوضاع خوبی ندارم
              </div>
            </div>
            <div v-if="this.form.loosingWeight">
              <div>چقدر با روش لاغری ما آشنایی داری؟</div>
              <div v-if="this.form.loosingWeight === 1">
                دکتر کرمانی رو از قدیم میشناسم
              </div>
              <div v-else-if="this.form.loosingWeight === 2">
                قبلا با شما رژیم گرفتم
              </div>
              <div v-else-if="this.form.loosingWeight === 3">
                چند نفر از آشنایان، با رژیم شما لاغر شدند
              </div>
              <div v-else-if="this.form.loosingWeight === 4">
                به تازگی آشنا شدم و هیچ شناختی از شما ندارم
              </div>
            </div>
            <div v-if="this.form.foodLover" class="my-5">
              <div>عاشق کدوم غذا یا خوراکی هستی؟</div>
              <div>{{ this.form.foodLover }}</div>
            </div>
            <div v-if="this.form.foodHater" class="my-5">
              <div>از کدوم غذا یا خوراکی متنفری ؟</div>
              <div>{{ this.form.foodHater }}</div>
            </div>
            <div v-if="this.form.diet" class="my-5">
              <div>قبلا سابقه رژیم داشتی؟</div>
              <div v-if="this.form.diet === 1">
                <div>بله</div>
                <div v-if="this.form.dietKind">
                  نوع رژیم : {{ this.form.dietKind }}
                </div>
                <div class="text-sm">از رژیمت راضی بودی؟</div>
                <div class="flex text-sm">
                  <div v-if="this.form.satisfied === 1">بله ،</div>
                  <div v-else-if="this.form.satisfied === 2">خیر ،</div>
                  <div v-if="this.form.quitCause">
                    {{ this.form.quitCause }}
                  </div>
                </div>
              </div>
              <div v-else-if="this.form.diet === 2">خیر</div>
            </div>
          </div>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/Slider";
import ButtonComponent from "@/components/Button";
import CheckBox from "@/components/checkBox";
import TextInput from "@/components/TextInput";
import CountryFlagCode from "@/components/CountryFlagCode";
import axios from "axios";
import CountSvg from "@/components/Icons/Count";
import PointerSvg from "@/components/Icons/Pointer";
import WomanSvg from "@/components/Icons/Woman";
import ManSvg from "@/components/Icons/Man";
import ThinFemale from "@/components/Icons/ThinFemale";
import NormalFemale from "@/components/Icons/NormalFemale";
import OverWeightFemale from "@/components/Icons/OverWeightFemale";
import FatFemale from "@/components/Icons/FatFemale";
import SupperFatFemale from "@/components/Icons/SupperFatFemale";
import ThinMale from "@/components/Icons/ThinMale";
import NormalMale from "@/components/Icons/NormalMale";
import OverWeightMale from "@/components/Icons/OverWeightMale";
import FatMale from "@/components/Icons/FatMale";
import SupperFatMale from "@/components/Icons/SupperFatMale";
import FemaleSvg from "@/components/Icons/Female";
import MaleSvg from "@/components/Icons/Male";
import BackGround from "@/components/Icons/BackGround";
import TextArea from "@/components/TextArea";
import VeryLowActivity from "@/components/Icons/VeryLowActivity";
import LowActivity from "@/components/Icons/LowActivity";
import NormalActivity from "@/components/Icons/NormalActivity";
import HeavyActivity from "@/components/Icons/Activity";
import UnderNumber from "@/components/Icons/UnderNumber";
import SelectBack2 from "@/components/Icons/SelectBack2";
import SelectBack3 from "@/components/Icons/SelectBack3";
import SelectBack4 from "@/components/Icons/SelectBack4";
import SelectBack5 from "@/components/Icons/SelectBack5";
import UnderFat from "@/components/Icons/UnderFat";
import FullFatTop from "@/components/Icons/FullFatTop";
import LowerBodyFat from "@/components/Icons/LowerBodyFat";
import FullLowerFat from "@/components/Icons/FullLowerFat";
import BellyFat from "@/components/Icons/BellyFat";
import BellyChuby from "@/components/Icons/Belly";
import WarningSvg from "@/components/Icons/Warning";
import WeightSvg from "@/components/Icons/WeightSvg";
import ClockSvg from "@/components/Icons/Clock";

export default {
  name: "HomeView",
  components: {
    ClockSvg,
    WeightSvg,
    WarningSvg,
    BellyChuby,
    BellyFat,
    FullLowerFat,
    LowerBodyFat,
    FullFatTop,
    UnderFat,
    SelectBack5,
    SelectBack4,
    SelectBack3,
    SelectBack2,
    UnderNumber,
    HeavyActivity,
    NormalActivity,
    LowActivity,
    VeryLowActivity,
    TextArea,
    BackGround,
    MaleSvg,
    FemaleSvg,
    SupperFatMale,
    FatMale,
    OverWeightMale,
    NormalMale,
    ThinMale,
    SupperFatFemale,
    FatFemale,
    OverWeightFemale,
    NormalFemale,
    ThinFemale,
    ManSvg,
    WomanSvg,
    PointerSvg,
    CountSvg,
    CheckBox,
    TextInput,
    ButtonComponent,
    Slider,
    CountryFlagCode,
  },
  data() {
    return {
      state: {
        weight: "65",
        height: "160",
        age: "20",
      },
      form: {
        mobile: "",
        weightCause: "",
        foodLover: "",
        foodHater: "",
        dietKind: "",
        quitCause: "",
        disease: "",
        gender: 0,
        fatAround: 0,
        activity: 0,
        contact: 0,
        paying: 0,
        info: 0,
        sleep: 0,
        stress: 0,
        motivation: 0,
        outFood: 0,
        eating: false,
        eating1: false,
        eating2: false,
        eating3: false,
        eating4: false,
        eating5: false,
        eating6: false,
        financial: 0,
        loosingWeight: 0,
        diet: 0,
        satisfied: 0,
        result: 0,
        looseWeight: 0,
        con1: false,
        con2: false,
        con3: false,
        con4: false,
        con5: false,
        con6: false,
        con7: false,
        con8: false,
        con9: false,
        con10: false,
      },
      countyCode: "",
      steps: {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
        12: 12,
        13: 13,
        14: 14,
        15: 15,
        16: 16,
        17: 17,
        18: 18,
        19: 19,
        20: 20,
        21: 21,
      },
      step: 1,
      errors: "",
      bmiResult: "",
      normal_weight:"",
      fitness_weight:"",
      health_weight:"",
      less_weight:"",
      add_weight:"",
      months:0,
    };
  },
  methods: {
    finalCalc(){
      const weight = this.state.weight;
      const height = this.state.height
      let result = weight / Math.pow(height / 100, 2).toFixed(2);
      this.bmiResult = Math.round(result);
    },
    async handleMobile() {
      if (this.form.mobile.length === 10) {
        this.form.mobile = "0" + this.form.mobile;
      }
      const token = "nz9XS54cGjV7nfPfASDF@#$ASDfEHuQP3kGm2rymF\n";
      await axios
          .post(
              "https://crm.bornafit.ir/api/getnumber",
              {
                mobile: this.form.mobile,
                repositoty: 1,
                topic: 31,
              },
              {
                headers: {
                  token,
                },
              }
          )
          .then(() => {
            this.next();
          })
          .catch((e) => {
            if ([422].includes(e.response.status)) {
              this.errors = e.response.data.error[0];
              document.getElementById("error").innerHTML = this.errors;
              if (this.errors) {
                document.getElementById("errors").style.borderColor = "red";
              }
            }
          });
    },
    inputValiation(countryCode) {
      this.countyCode = countryCode;
    },
    bmiCalculating() {
      const weight = this.state.weight;
      const height = this.state.height;
      const age = this.state.age;
      let result = weight / Math.pow(height / 100, 2).toFixed(2);
      this.bmiResult = Math.round(result);
      let height_m = height / 100;

      if (this.form.gender === 0) {
        if (age >= 16 && age < 31) {
          this.normal_weight = height_m * height_m * 20.8;
          console.log(this.normal_weight)
        } else if (age >= 31 && age < 40) {
          this.normal_weight = height_m * height_m * 22.5;
          console.log(this.normal_weight)
        } else if (age >= 40 && age < 45) {
          this.normal_weight = height_m * height_m * 24.1;
          console.log(this.normal_weight)
        } else if (age >= 45) {
          this.normal_weight = height_m * height_m * 25;
          console.log(this.normal_weight)
        }
      } else {
        if (age >= 16 && age < 31) {
          this.normal_weight = height_m * height_m * 23.3;
          console.log(this.normal_weight)
        } else if (age >= 31 && age < 45) {
          this.normal_weight = height_m * height_m * 24.8;
          console.log(this.normal_weight)
        } else if (age >= 45) {
          this.normal_weight = height_m * height_m * 25.4;
          console.log(this.normal_weight)
        }
      }

      if ((10 <= age) && (age <= 11) && (height_m < 1.65)) {
         this.normal_weight = (height_m * height_m) * (age + 8);
        console.log(this.normal_weight)
      } else if ((12 <= age) && (age <= 15) && (height_m <= 1.65)) {
         this.normal_weight = (height_m * height_m) * (age + 5);
        console.log(this.normal_weight)
      } else if ((10 <= age) && (age <= 15) && (height_m >= 1.65)) {
        if (this.form.gender === 1) {
           this.normal_weight = (height_m * height_m) * 23.3;
          console.log(this.normal_weight)
        } else {
           this.normal_weight = (height_m * height_m) * 20.8;
          console.log(this.normal_weight)
        }
      }

      this.normal_weight = Math.round(this.normal_weight);
      this.fitness_weight = Math.round(this.normal_weight * 90 / 100);
      this.health_weight = Math.round(this.normal_weight * 112 / 100);

      this.add_weight  = weight - this.normal_weight;
      this.less_weight = this.normal_weight - weight;

      if (this.add_weight > 0) {
        let upHundred        = this.upHundred(weight, this.normal_weight);
        let between          = this.between(weight, this.normal_weight);
        let underSeventy     = this.underSeventy(weight, this.normal_weight);
        let timeUpHundred    = upHundred/4;
        let timeBetween      = between/3.5;
        let timeUnderSeventy = underSeventy/3;
        this.months = Math.round(timeUpHundred + timeBetween + timeUnderSeventy);
      } else if (this.less_weight > 0) {
        this.months = (Math.round(this.less_weight/0.8));
      } else {
        this.months = '0';
      }
      console.log(this.add_weight)
    },
    upHundred(weight, normal_weight) {
      if(weight < 100) {
        weight = 0;
      } else if(normal_weight > 100) {
        weight = weight - normal_weight;
      } else if(normal_weight < 100) {
        weight = weight - 100;
      }
      return weight;
    },
    between(weight, normal_weight) {
      if(weight < 70 || normal_weight > 100) {
        return 0;
      }
      if(weight > 100) {
        if(normal_weight < 70) {
          weight = 100 - 70;
        } else {
          weight = 100 - normal_weight;
        }
      } else {
        if(normal_weight < 70) {
          weight = weight - 70;
        } else {
          weight = weight - normal_weight;
        }
      }
      return weight;
    },
    underSeventy(weight, normal_weight) {
      if(normal_weight > 70) {
        return 0;
      } else if(weight < 70) {
        weight = weight - normal_weight;
      } else {
        weight = 70 - normal_weight;
      }
      return weight;
    },
    gender() {
      this.next();
    },
    next() {
      const steps = Object.keys(this.steps);
      this.step = this.step >= steps.length ? steps.length : this.step + 1;
      sessionStorage.setItem("steps", this.step);
      sessionStorage.setItem("formStore", JSON.stringify(this.$data));
    },
    back() {
      this.step = this.step <= 1 ? 1 : this.step - 1;
    },
    emptyInput() {
      if (this.errors) {
        if (this.form.mobile.length < 10) {
          document.getElementById("error").innerHTML = "";
          document.getElementById("errors").style.borderColor = "";
        }
      }
      let style = document.getElementById("disabledButton");
      if (this.form.mobile > 0) {
        style.classList.add("purple");
        style.classList.remove("disable-mode");
      }
      let maxVal = 11;
      let minVal2 = 6;
      if (this.countyCode === "98") {
        if (this.form.mobile.length >= maxVal) {
          this.form.mobile = this.form.mobile.substring(0, maxVal);
        }
      } else {
        if (this.form.mobile.length >= minVal2) {
          this.form.mobile = this.form.mobile.substring(0, maxVal);
        }
        if (this.form.mobile.length < minVal2) {
          document.getElementById("errors").style.borderColor = "red";
          document.getElementById("error2").innerHTML =
              "شماره وارد شده باید حداقل بین ۶ تا ۱۰ رقم  باشد";
        } else if (this.form.mobile.length > 6) {
          document.getElementById("errors").style.borderColor = "";
          document.getElementById("error2").innerHTML = "";
        }
      }
    },
  },

  watch: {
    $data: {
      handler() {
        console.log("set Data");
        sessionStorage.setItem("formStore", JSON.stringify(this.$data));
      },
      deep: true,
    },
    step: {
      handler(val) {
        if (val === 5) {
          let bmi = "";
          let bmiResult = "";

          if (this.bmiResult < 18) {
            //کمبود وزن
            bmi = "low";
            bmiResult = "low1";
          } else if (this.bmiResult > 19 && this.bmiResult <= 24) {
            //تثبیت
            bmi = "normal";
            bmiResult = "normal1";
          } else if (this.bmiResult > 25 && this.bmiResult <= 29) {
            //افزایش وزن ۱
            bmi = "overWeight";
            bmiResult = "overWeight1";
          } else if (this.bmiResult > 30 && this.bmiResult <= 34) {
            //افزایش وزن سطح ۲
            bmi = "fat1";
            bmiResult = "fat2";
          } else if (this.bmiResult > 35) {
            //چاقی مفرط
            bmi = "fat";
            bmiResult = "fat3";
          }

          setTimeout(() => {
            document.getElementById("bmi").classList.add(bmi);
            document.getElementById("bmiResult").classList.add(bmiResult);
          }, 250);
        }
      },

      immediate: true,
    },
  },

  mounted() {
    const sessionStorage = window.sessionStorage.getItem("formStore");
    if (sessionStorage) {
      for (let key in this.$data) {
        this[key] = JSON.parse(sessionStorage)[key];
      }
    }
  },
};
</script>

<style scoped>
@media screen and (max-height: 640px) {
  .margin_custom{
    margin-bottom: 20px !important;
  }
  .mb_custom{
    margin-bottom: 10px !important;
  }
}
.low {
  transition: all 0.6s ease;
  transform: rotate(90deg);
  right: 8px;
  bottom: -60px;
}

.low1 {
  transition: all 0.6s ease;
  transform: rotate(75deg);
  right: 0px;
  top: 185px;
  display: flex;
}

.normal {
  transition: all 0.6s ease;
  transform: rotate(52deg);
  right: 8px;
  bottom: -65px;
}

.normal1 {
  transition: all 0.6s ease;
  transform: rotate(40deg);
  right: 64px;
  top: 94px;
  display: flex;
}

.overWeight {
  transition: all 0.6s ease;
}

.overWeight1 {
  transition: all 0.6s ease;
  display: flex;
}

.fat1 {
  transition: all 0.6s ease;
  transform: rotate(-52deg);
  left: 8px;
  bottom: -65px;
}

.fat2 {
  transition: all 0.6s ease;
  transform: rotate(-38deg);
  left: 64px;
  top: 94px;
  display: flex;
}

.fat {
  transition: all 0.6s ease;
  transform: rotate(-90deg);
  left: 8px;
  bottom: -60px;
}

.fat3 {
  transition: all 0.6s ease;
  transform: rotate(-75deg);
  left: 0px;
  top: 185px;
  display: flex;
}
</style>